import { Spin } from "antd";
import { AiOutlinePrinter } from "react-icons/ai";
import DocumentWrapper from "./components/DocumentWrapper";
import ReactToPrint from "react-to-print";
import { useEffect, useRef, useState } from "react";
import fetchStatement from "../../../services/fetchStatement";
import splitIntoChunks from "../../../utils/splitIntoChunks";
import NoResults from "../../../components/shared/NoResults";
import { useParams } from "react-router";

export default function Statement({ selected }: any) {
  const docRef = useRef(null);
  const [isLoading, setLoading] = useState(false);
  const [statements, setStatements] = useState<any>([]);
  const [allTransaction, setTransactions] = useState<any>([]);

  const { account } = useParams();

  const handleFetchStatements = async () => {
    setLoading(true);
    const data = await fetchStatement(account);
    const chunks = splitIntoChunks(data, 17);
    setTransactions(data);
    setStatements(chunks);
    setLoading(false);
  };

  useEffect(() => {
    handleFetchStatements();
  }, [selected]);

  const getTotalDue = () => {
    let total = 0;

    allTransaction.forEach((item: any) => {
      total = total + item.outstanding;
    });
    return total;
  };

  return (
    <div>
      <div className="flex flex-row justify-center items-center  p-4  mt-4">
        <div className="border border-toyota p-4 rounded-md">
          <ReactToPrint
            trigger={() => {
              return (
                <button className="flex justify-center items-center focus:outline-none hover:text-red-500 mr-2 text-3xl">
                  <AiOutlinePrinter className="mr-2" /> Download
                </button>
              );
            }}
            content={() => docRef.current}
            documentTitle={`Statement`}
          />
        </div>
      </div>
      <div className="flex flex-row bg-whitish  justify-center items-start overflow-auto">
        <div className="bg-white px-4">
          {isLoading ? (
            <div className="">
              <Spin />
            </div>
          ) : (
            <div className="">
              {statements.length === 0 ? (
                <div className="flex justify-center items-center mt-16">
                  <NoResults />
                </div>
              ) : (
                <div className="book" ref={docRef}>
                  {statements.map((page: any, index: number) => (
                    <div className="page" key={index}>
                      <div className="subpage">
                        <DocumentWrapper
                          statements={page}
                          selected={selected}
                          pageno={index + 1}
                          pages={statements.length}
                          getTotalDue={getTotalDue}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
